import { useHistory } from 'react-router-dom';
import { useMutation } from "@apollo/client";

import { GRAPHIC_LIST_DELETE } from "graphql/mutation/graphic-packing-gql";

import GraphicPackingConst from '../graphic-packing-const';
import { successNotification, errorNotification } from "components/request-result";

const useMutationGraphicPackingDelete = (id) => {
  const history = useHistory();

  const [ _setMutationGraphicPackingDelete, { loading } ] = useMutation(GRAPHIC_LIST_DELETE,
    {
      update(cache, { data }) {
        const {
          graphicListDelete: {
            label,
            message
          }
        } = data;

        history.push(`${ GraphicPackingConst.basePath }/`);

        cache.evict({
          id: cache.identify({ id, __typename: "GraphicList" })
        });
        cache.gc();

        successNotification({
          title: label.toUpperCase(),
          description: message
        });
      },
      onError(error) {
        errorNotification(error);
      }
    });

  return {
    _setMutationGraphicPackingDelete,
    loadingMutationGraphicPackingDelete: loading,
  }
};

export default useMutationGraphicPackingDelete;